export default __webpack_public_path__ + "static/plumber-8bit-d7aa3b405acc61501ec59b4e18e882fe.svg";